import { render, staticRenderFns } from "./dialogAbout.vue?vue&type=template&id=efbb551c&scoped=true"
import script from "./dialogAbout.vue?vue&type=script&lang=js"
export * from "./dialogAbout.vue?vue&type=script&lang=js"
import style0 from "./dialogAbout.vue?vue&type=style&index=0&id=efbb551c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbb551c",
  null
  
)

export default component.exports